import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import { FaHeart } from 'react-icons/fa6'
import BottomBar from '../component/BottomBar'
import { Helmet } from 'react-helmet-async'

function Story() {

    const donationClick =()=>{
        const menu_dropdown = document.querySelector(".donate_header")
        menu_dropdown.classList.toggle("donate_dropDown");
      }
    

  return (
    <>
        <Helmet>
            <title>Our Story | The Lord Nations Foundation</title>
            <meta name="description" content="Discover the inspiring journey of The Lord Nations Foundation. Learn about our mission, vision, and the impact we strive to create in communities worldwide." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='stories_banner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>STORIES</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>
            
            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>Looking Ahead: The Future of Our Foundation</h1>
                </div>

                <p>
                    We are just at the beginning of a journey that we hope will create lasting change in the lives of those who need it most. While our first steps have been small, they have been filled with purpose, passion, and a commitment to making a difference. In the coming months, we plan to expand our outreach to reach more families and individuals struggling with poverty, homelessness, and lack of access to education. We want to ensure that no one is left behind—whether it’s by providing food, shelter, mentorship, or healthcare support.
                </p>

                <p>
                    One of our biggest goals is to launch sustainable programs that go beyond short-term relief. We believe in empowerment—helping people not just to survive, but to build a better future. This means creating skill-building workshops, offering educational scholarships, and providing micro-funding opportunities for small businesses in underserved communities.
                </p>

                <p>
                    We also plan to strengthen our community partnerships—collaborating with local businesses, schools, and organizations to multiply our impact. We know that real change happens when people come together with a shared vision, and we are dedicated to building a network of changemakers who believe in compassion and action.
                </p>

                <p>
                    But we can’t do this alone. Every donation, every volunteer, and every act of kindness brings us one step closer to transforming lives. You don’t have to be rich to make a difference—you just have to care.
                </p>

                <h3 style={{width:'100%', color:'#ee1f10'}}>
                    Be part of the story. Join us in bringing hope, opportunity, and change to those who need it most. 
                </h3>
                
                <div className='about_sub' >
                    <div className='about_sub_header'>
                        <div className='about_sub_header_line'></div>
                        <h2>Get Involved</h2>
                    </div>
        
                    <p>
                    Your support can change lives! Whether by donating, volunteering, or spreading awareness, you can be a part of this movement of hope.
                    </p>
        
                    <div className='about_donation_link'>
                    <h3>Join us today and be the reason someone smiles!</h3>
                    <div onClick={()=>donationClick()} className='about_header_donate_btn'>
                        <FaHeart className='desk_header_donate_btn_icon' />
                        <h3>DONATE</h3>
                    </div>
                    </div>
                </div>
            </div>

            <BottomBar/>
        </div>
    </>
  )
}

export default Story